module.exports = __webpack_public_path__ + "img/universityBannerImg.79efb41a.png";